import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlice: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="slice, knife"><path d="M6.48722 3.42687C5.8038 2.74345 4.69576 2.74345 4.01234 3.42687L2.42663 5.01259C1.74316 5.69605 1.74321 6.80418 2.42674 7.48758L6.93047 11.9904L4.2836 14.5535C4.13936 14.6932 4.05714 14.8849 4.05537 15.0857C4.05359 15.2865 4.1324 15.4796 4.27415 15.6218C7.42284 18.7807 10.124 20.3147 12.8954 20.8107C15.6398 21.3019 18.3513 20.752 21.4326 19.9775C21.6945 19.9116 21.9008 19.7101 21.9727 19.4498C22.0446 19.1896 21.9711 18.9107 21.7801 18.7198L6.48722 3.42687Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSlice;
